import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import OutboundLink from '../OutboundLink';

import Icon from '../../shared/Icon/index.tsx';
import { Box } from '../../shared/Box/index.tsx';
import { trackEvent } from '../../modules/analytics';

import styles from './PlatformBadge.sass';

const cx = classnames.bind(styles);
const noop = () => null;

function getPlatformData(platformName) {
  switch (platformName) {
    case 'apple':
      return {
        iconType: 'apple_logo',
        label: 'App Store',
        eventPlatformName: 'App Store',
      };
    case 'google':
      return {
        iconType: 'google_play_logo',
        label: 'Google Play',
        eventPlatformName: 'Play Store',
      };
    default:
      return null;
  }
}

const PlatformBadge = ({
  contentClass,
  platformName,
  url,
  clickEventLocation,
  clickEventSection,
}) => {
  const { iconType, label, eventPlatformName } = getPlatformData(platformName);
  return (
    <OutboundLink
      to={url}
      newWindow
      className={styles.platformBadgeLink}
      onClick={() => {
        if (clickEventLocation) {
          const eventLabel = clickEventSection
            ? `${clickEventSection} ${eventPlatformName} Button`
            : `${eventPlatformName} Button`;
          trackEvent(
            null,
            {
              eventCategory: clickEventLocation,
              eventAction: 'Click',
              eventLabel,
            },
            { providers: [ga] }
          );
        }
      }}
    >
      <div className={styles.platformBadge}>
        <div
          className={cx({
            platformBadgeContent: true,
            [contentClass]: true,
          })}
        >
          <div className={styles.platformBadgeIconContainer}>
            <Box>
              <Icon type={iconType} fillColor="#ffffff" />
            </Box>
          </div>
          <div className={styles.platformBadgeLabel}>{label}</div>
        </div>
      </div>
    </OutboundLink>
  );
};

PlatformBadge.defaultProps = {
  contentClass: '',
  renderIcon: noop,
};

export { PlatformBadge };
